/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { css } from '@emotion/react';
import { COOL_GREY, WHITE, RED_CREEK } from '../styles/colors';
import { MediumText } from '../styles/styles';

const MAX_ERROR_DISPLAY = 500;

const ovalLabel = css`
  margin: auto;
  padding: 5px;
  width: 60px;
  height: 25px;
  border-radius: 25px;
  text-align: center;
  vertical-align: middle;
  color: ${WHITE};
   ${MediumText};
`;

const errorLabel = css`
    background-color: ${RED_CREEK};
`;

const infoLabel = css`
    background-color: ${COOL_GREY};
`;


const valueTextLabel = css`
  display:inline-block;
  vertical-align: middle;
  padding-top:3px;
`;

export default class ErrorCountSummary extends React.PureComponent<{
  value?: number;
  /** Shown in the zero style instead of a count that is not known. */
  placeholder?: string;
}> {
  public render() {
    if (this.props.placeholder !== undefined) {
      return (
        <div css={css`${ovalLabel} ${infoLabel}`}>
          <div css={css`${valueTextLabel}`}>{this.props.placeholder}</div>
        </div>
      )
    }
    let conditionalLabelStyle = (this.props.value ?? 0) > 0 ? css`${errorLabel}` : css`${infoLabel}`;
    let displayValue = (this.props.value ?? 0) > MAX_ERROR_DISPLAY ? `${MAX_ERROR_DISPLAY}+` : this.props.value;
    return (
      <div css={css`${ovalLabel} ${conditionalLabelStyle}`}>
        <div css={css`${valueTextLabel}`}>{displayValue}</div>
      </div>
    )
  }
}
